import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EDMUNDS_LOGO_TEXT } from 'client/images/inline-svgs/edmunds-logo-text';
import { AppraisalTabsContainer } from 'site-modules/shared/components/appraisal/appraisal-tabs-container/appraisal-tabs-container';

import './core-appraisal.scss';

const CORE_6912_MAP = {
  chal1: {
    heading: 'Selling or Trading-In?',
    text: 'Know what your car is worth while you shop for your next vehicle.',
    cta: "See my car's value",
  },
  chal2: {
    heading: 'Know your buying power',
    text: "Shop smarter by knowing your car's value.",
    cta: 'Appraise my car',
  },
};

export function CoreAppraisal({ className, isMobile, core6912Recipe }) {
  const { heading, text, cta } = CORE_6912_MAP[core6912Recipe];

  return (
    <div className={classnames('core-appraisal bg-white rounded-8', className)}>
      <div className="text-center text-md-start">
        {EDMUNDS_LOGO_TEXT({
          className: 'mb-1',
          width: 80,
          fillColor: '#475569',
          iconFillColor: '#007ee5',
        })}
        <h2 className="heading-4 mb-0_25">{heading}</h2>
        <div className="mb-1_5">{text}</div>
      </div>
      <AppraisalTabsContainer
        className="border-0 box-shadow-none"
        accentBgColorClassName={null}
        linksColorClassName="text-blue-40"
        isMobile={isMobile}
        hideEdmundsLogo
        isFullWidth
        isLicensePlateTabDefault
        isSimpleTabsCopy
        isProjectEveStyle
        withContainerPadding={false}
        ctaBtnColor="blue-50"
        ctaText={cta}
      />
    </div>
  );
}

CoreAppraisal.propTypes = {
  className: PropTypes.string,
  core6912Recipe: PropTypes.string,
  isMobile: PropTypes.bool,
};

CoreAppraisal.defaultProps = {
  className: null,
  core6912Recipe: 'chal1',
  isMobile: false,
};
